import React from 'react';
import { Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: 'var(--varexe-gray-100)',
      }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!isAuthenticated) {
    const orgId = typeof localStorage !== 'undefined' ? localStorage.getItem('organization_public_id') : null;
    const to = orgId ? `/${orgId}/login` : '/login';
    return <Navigate to={to} replace />;
  }

  return children;
};

export default ProtectedRoute;
